import { SAFE_PLACE_NAME } from "@dpdgroupuk/redback-enums";
export { default } from "./SafePlaceItem";
export const createSafePlace = (type, customName) => ({
  id: type,
  name: customName || SAFE_PLACE_NAME[type]
});